module.exports = __webpack_public_path__ + "img/chrome.99f0b30c.svg";